module.exports = __webpack_public_path__ + "img/i30_fastback.c6f50d26.png";